import apiFetch from '../apiFetch'

export default function (token, maritalStatus) {
  return apiFetch({ endPoint: 'MaritalStatus', method: 'POST', body: maritalStatus, token: token })
}
